module.exports = __webpack_public_path__ + "static/img/icon_gps.3d4ac24a.png";